import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Card, CardBody, Col, DropdownItem, Row } from "reactstrap";
import {
  ActionsRow,
  FixedDropDownButton,
  HorizontalLoader,
  Icon,
  InfiniteScroll,
  Loader,
  modal,
  utils,
} from "@mc/mc-legacy";
import { withRouter } from "react-router";
import ListForm from "../../forms/ListForm";
import QSignAdminApi from "../../../api/gen/qsign/QSignAdminApi";
import * as sablonaActions from "../../../actions/sablonaActions";
/**
 * Šablony - výpis / editace.
 */

class TemplateList extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    color: PropTypes.string,
  };
  static defaultProps = {
    type: "nevyrizene",
  };

  componentDidMount() {
    this.fetchData(this.props, true);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchData = (props, force) => {
    props.dispatch(sablonaActions.fetchfindMailTemplatesIfNeeded(false));
  };
  handleEditList = (item) => {
    console.warn(item);
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.showAsyncWaiting(
        "Načítání detailu šablony",
        <Loader />,
        QSignAdminApi.getMailTemplateDetail(item.id),
        (itemDetail) => {
          dispatch(
            modal.ModalActions.show(
              ListForm,
              {
                onSubmit: (data) => {
                  return QSignAdminApi.updateMailTemplate(data.id, data);
                },
                onSubmitSuccess: (result, dispatch) => {
                  dispatch(modal.ModalActions.hide());
                  dispatch(sablonaActions.fetchfindMailTemplatesIfNeeded(true));
                },
                //onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: itemDetail,
              },
              "Úprava šablony (" + item.name + ")",
              {
                size: "lg",
              }
            )
          );
        }
      )
    );
  };
  renderItem = (item, key) => {
    return (
      <Card key={key}>
        <CardBody>
          <ActionsRow actions={this.renderActions(item)}>
            <Row>
              <Col md={12}>
                <h2 title={item.name}>{item.name}</h2>
              </Col>
            </Row>
          </ActionsRow>
        </CardBody>
      </Card>
    );
  };
  renderActions = (item) => {
    return (
      <Col className="item-actions">
        <FixedDropDownButton
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          color="action"
          noCaret
          title={<Icon icon="ellipsis-v" className="item-actions-icon" />}
        >
          <DropdownItem key="1" onClick={() => this.handleEditList(item)}>
            Upravit
          </DropdownItem>
        </FixedDropDownButton>
      </Col>
    );
  };

  render() {
    const { sablonaListy } = this.props;

    if (!sablonaListy) {
      return <Loader />;
    }

    return (
      <InfiniteScroll className="config-list">
        {sablonaListy.isFetching && <HorizontalLoader key={'loader'} hover />}
        {sablonaListy.rows.map((item, key) => {
          return this.renderItem(item, key);
        })}
      </InfiniteScroll>
    );
  }
}

function mapStateToProps(state) {
  return {
    sablonaListy: utils.storeFromArea(state, sablonaActions.MAIN_TEMPLATES_LIST), // sablonaDetail: utils.storeFromArea(state, sablonaDetailActions.MAIN_TEMPLATES_DETAIL_LIST),
  };
}

export default withRouter(connect(mapStateToProps)(TemplateList));
